module.exports = __webpack_public_path__ + "img/slide12.f175930e.png";